// extracted by mini-css-extract-plugin
export default {"PrivacyContentBG":"PrivacyContent_PrivacyContentBG__NAl6q","PrivacyContent":"PrivacyContent_PrivacyContent__-djrL","section":"PrivacyContent_section__CWq1A"};